import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="px-6 py-6 text-xs text-primary-foreground/70 border-t border-primary-foreground/10">
      <div className="max-w-md mx-auto flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
        <Link to="/legal/terms" className="hover:text-primary-foreground">Terms</Link>
        <span aria-hidden>·</span>
        <Link to="/legal/privacy" className="hover:text-primary-foreground">Privacy</Link>
        <span aria-hidden>·</span>
        <Link to="/legal/refunds" className="hover:text-primary-foreground">Refunds</Link>
        <span aria-hidden>·</span>
        <Link to="/legal/escrow" className="hover:text-primary-foreground">Escrow</Link>
        <span aria-hidden>·</span>
        <Link to="/legal/disputes" className="hover:text-primary-foreground">Disputes</Link>
        <span aria-hidden>·</span>
        <Link to="/legal/acceptable-use" className="hover:text-primary-foreground">Acceptable use</Link>
        <span aria-hidden>·</span>
        <Link to="/support" className="hover:text-primary-foreground">Support</Link>
        <span aria-hidden>·</span>
        <Link to="/waitlist" className="hover:text-primary-foreground">Join the waitlist</Link>
      </div>
      <p className="mt-3 text-center text-[10px] opacity-70">
        © {new Date().getFullYear()} Cash Isle. Cash Isle is not a bank. Stored balances are not insured deposits.
      </p>
    </footer>
  );
};
